import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { onSesionPerdida, modoSoloLectura } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    onSesionPerdida.fn = () => setUser(false);
    api
      .get("/auth/me")
      .then(({ data }) => { modoSoloLectura.activo = data?.rol === "inversionista"; setUser(data); })
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    // Si el servidor está reiniciando (deploy) reintenta hasta 4 veces con espera creciente antes de mostrar error
    let data;
    for (let intento = 0; ; intento += 1) {
      try { ({ data } = await api.post("/auth/login", { email, password })); break; } catch (err) {
        if (err?.servidorNoDisponible && intento < 4) { await new Promise((r) => setTimeout(r, 2500 * (intento + 1))); continue; }
        throw err;
      }
    }
    modoSoloLectura.activo = data.user?.rol === "inversionista";
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, ready, login, logout, setUser }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
